export default __webpack_public_path__ + "static/media/call-a-person-contact-img3.c148fa63.svg";